import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { ModalNoticeUI } from '@cube3/ui/src/Modal/ModalNoticeUI';
import React from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';

export const CreateProjectNotice = (props) => {
  const { message, title, critical = false } = props.modalContext;

  const { previousModal } = useModalActions();

  return (
    <ModalNoticeUI
      title={title || 'Notice'}
      onCloseEvent={previousModal}
      footerRightComponent={<Button label="Close" onClick={previousModal} />}
    >
      <Typography color={critical ? 'critical' : 'default'}>
        {message}
      </Typography>
    </ModalNoticeUI>
  );
};
